











import { Component, Prop, Vue } from "vue-property-decorator";
import ImagePreview from "@/components/ImagePreview";

Vue.component("ImagePreview", ImagePreview);
@Component({
  name: "PayeeInfoPreview",
})
export default class PayeeInfoPreview extends Vue {
  @Prop({ type: String })
  public readonly imageSrc!: string;
}
